import { render, staticRenderFns } from "./globalHeaderNav.vue?vue&type=template&id=5611207a"
import script from "./globalHeaderNav.vue?vue&type=script&lang=ts"
export * from "./globalHeaderNav.vue?vue&type=script&lang=ts"
import style0 from "./globalHeaderNav.vue?vue&type=style&index=0&id=5611207a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports